"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubjectDisplayName = exports.SUBJECT_CODE_MAP = void 0;
// 대인라 과목 코드 체계 (수능예상점수 업로드 양식 기준)
// 선택과목이 공통이면 과목명만, 아니면 과목명(선택과목) 형식
exports.SUBJECT_CODE_MAP = {
    '01': '국어',
    '02': '수학',
    '03': '영어',
    '04': '통합사회',
    '05': '통합과학',
    '06': '국어(언어와매체)',
    '07': '국어(화법과작문)',
    '08': '수학(확률과통계)',
    '09': '수학(미적분)',
    '10': '수학(기하)',
    '11': '사회문화',
    '12': '생활과윤리',
    '13': '물리I',
    '14': '화학I',
    '15': '생명과학I',
    '16': '지구과학I',
    '17': '물리II',
    '18': '화학II',
    '19': '생명과학II',
    '20': '지구과학II',
    '21': '국어(독서)',
    '22': '국어(문학)',
};
const getSubjectDisplayName = (code) => {
    if (code === null || code === undefined)
        return String(code ?? '');
    const normalized = String(code).trim().padStart(2, '0');
    return exports.SUBJECT_CODE_MAP[normalized] ?? String(code);
};
exports.getSubjectDisplayName = getSubjectDisplayName;
